import { TypeComponentCtaAskAi } from '@/types/ctf'
import CtaLink from './cta-link'
import { useSearch } from '../search-provider'

export type CtaAskAiProps = TypeComponentCtaAskAi<'WITHOUT_UNRESOLVABLE_LINKS'>['fields']

export default function CtaAskAi({ prompt, label, ...props }: CtaAskAiProps) {
  const { isAskAiEnabled, askAi } = useSearch()
  if (!isAskAiEnabled) return null
  return (
    <CtaLink
      asButton
      {...props}
      onClick={() => {
        askAi(prompt)
      }}
    >
      {label}
    </CtaLink>
  )
}
